var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 6.75V13.5C16.0312 14.2767 15.4017 14.9062 14.625 14.9062H3.375C2.59834 14.9062 1.96875 14.2767 1.96875 13.5V4.95V4.5C1.96875 3.72334 2.59834 3.09375 3.375 3.09375H6.38052C6.75348 3.09375 7.11117 3.24191 7.37489 3.50564L8.63638 4.76712C9.00559 5.13633 9.50635 5.34375 10.0285 5.34375H14.625C15.4017 5.34375 16.0312 5.97335 16.0312 6.75Z",
    fill: "#EBEBEB",
    fillOpacity: 0.49,
    stroke: "#0D0D0D",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1742_6389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3513 5.25879H11.2582C10.9958 5.25879 10.7822 5.45732 10.7822 5.70173V11.8658C10.7822 12.1107 10.9958 12.3088 11.2582 12.3088H15.3513C15.6137 12.3088 15.8273 12.1107 15.8273 11.8658V5.70173C15.8273 5.45732 15.6141 5.25879 15.3513 5.25879ZM14.0098 6.15261H13.5494V6.55232H14.0098V7.03497H13.5494V7.43467H14.0098V7.91732H13.5494V8.32408H14.0024V10.1095H12.6071V8.32408H13.0674L13.0601 7.47614H12.5997V6.99349H13.0601V6.59379H12.5997V6.11114H13.0601V5.66997H14.0093V6.15261H14.0098Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5139 8.7793H13.0752V9.19974H13.5139V8.7793Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1742_6389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.82609,
    height: 7.5,
    fill: "white",
    transform: "translate(9.3916 5.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folderIcon.a1070747528ec910a6cf053d83c9df4c.svg";
export { ForwardRef as ReactComponent };